export default __webpack_public_path__ + "static/media/Fantasy_01.a432d136.png";